import { ProductCategoryType } from '@iota/iota-management-portal-v4-client';
import { ProductCategory } from '@iota/inh-core-v1-management-client';

// Must cover every category of both clients; a missing translation breaks the build.
const productCategoryDescriptions: { [key in ProductCategoryType | ProductCategory]: string } = {
    HEALTH_COMBI: $localize`Health combi (common budget)`,
    HEALTH_BUNDLE: $localize`Health bundle (ind. budget limits)`,
    BIKE_LEASING: $localize`Bike-Leasing`,
    CASH_OUT: $localize`Cash Payment`,
    HEALTH_BENEFIT: $localize`Health Benefit`,
    HEALTH_CARE: $localize`Preventive healthcare`,
    NUTRITIONAL_COUNSELING: $localize`Nutrition`,
    NUTRITION: $localize`Nutrition`,
    ONLINE_FITNESS: $localize`Online Fitness`,
    DAYS_IN_LIEU: $localize`Day(s) in lieu`,
    STATIONARY_STAY: $localize`In-hospital stay (Demo)`,
    SERIOUS_ILLNESS_INSURANCE: $localize`Severe diseases (Demo)`,
    PREVENTION_COURSES: $localize`Prevention courses`,
    MENTAL_COUNCELING: $localize`Change of perspective`,
    MENTAL_STRENGTH: $localize`Mental Strength`,
    MIND_WHISPERERS: $localize`Mind whispers`,
    XTEND: $localize`Xtend`,
    COMPANY_PENSION_SCHEME: $localize`Occupational pension scheme`,
    THERAPIST_SEARCH_AUSTRIA: $localize`Therapists search`,
    MOCK_BASKET_PRODUCT: $localize`Demo-basket-product`,
    HEALTH_CHECK_UP_CUSTOMER_LEHMANN_UND_VOSS: $localize`Health Check-up | Customer LUV`,
    PREVENTION_COURSES_ONLINE_ONLY: $localize`Prevention courses - online only`,
    CORPORATE_FITNESS: $localize`Corporate fitness`,
    URBAN_SPORTS_CLUB: $localize`Urban Sports Club - monthly`,
    URBAN_SPORTS_CLUB_PRIVATE_MEMBERSHIP: $localize`Urban Sports Club - Private Membership`,
    BOOMERANG_REISEN: $localize`Boomerang Reisen`,
    UNKNOWN_CATEGORY: $localize`Unknown category`,
    SDK_GESUNDWERKER_PREVENTIVE_CARE: $localize`SDK Gesundwerker - Preventive Care`,
    SDK_GESUNDWERKER_AMBULATORY_BUDGET: $localize`SDK Gesundwerker - Ambulatory Budget`,
    SDK_GESUNDWERKER_DENTAL_BUDGET: $localize`SDK Gesundwerker - Dental Budget`,
    SDK_GESUNDWERKER_INPATIENT_CARE: $localize`SDK Gesundwerker - Inpatient Care`
};

export const ProductCategoryDescriptions = new Map(Object.entries(productCategoryDescriptions));

// Superseded by NUTRITIONAL_COUNSELING and unused in the database, so it must not be selectable.
// Its description is kept above so any legacy record still renders a label.
const NON_SELECTABLE_PRODUCT_CATEGORIES: ProductCategoryType[] = [ProductCategoryType.NUTRITION];

// Every other backend category is selectable; sorted by description so the dropdown order stays stable.
export const ProductCategories: string[] = Object.values(ProductCategoryType)
    .filter((category) => !NON_SELECTABLE_PRODUCT_CATEGORIES.includes(category))
    .sort((first, second) => productCategoryDescriptions[first].localeCompare(productCategoryDescriptions[second]));

// Categories without their own product picture fall back to another category's image.
export const PRODUCT_CARD_IMAGE_CATEGORIES: Partial<Record<ProductCategoryType, ProductCategoryType>> = {
    [ProductCategoryType.URBAN_SPORTS_CLUB_PRIVATE_MEMBERSHIP]: ProductCategoryType.URBAN_SPORTS_CLUB,
    [ProductCategoryType.SDK_GESUNDWERKER_PREVENTIVE_CARE]: ProductCategoryType.XTEND
};

export const ProductCategoryLabel: { [key in ProductCategoryType | ProductCategory]: string } = {
    BIKE_LEASING: $localize`Bike Leasing`,
    CASH_OUT: $localize`Cash out`,
    HEALTH_BENEFIT: $localize`Health benefit`,
    HEALTH_CARE: $localize`Health care`,
    NUTRITIONAL_COUNSELING: $localize`Nutritional counseling`,
    ONLINE_FITNESS: $localize`Online fitness`,
    DAYS_IN_LIEU: $localize`Vacation`,
    STATIONARY_STAY: $localize`Stationary stay`,
    SERIOUS_ILLNESS_INSURANCE: $localize`Serious illness insurance`,
    PREVENTION_COURSES: $localize`Prevention courses`,
    MENTAL_COUNCELING: $localize`Mental counceling`,
    MENTAL_STRENGTH: $localize`Mental Strength`,
    XTEND: $localize`Xtend`,
    MIND_WHISPERERS: $localize`Mind whispers`,
    COMPANY_PENSION_SCHEME: $localize`Company pension scheme`,
    HEALTH_COMBI: $localize`Health combi (common budget)`,
    HEALTH_BUNDLE: $localize`Health bundle`,
    THERAPIST_SEARCH_AUSTRIA: $localize`Therapist search (austria)`,
    MOCK_BASKET_PRODUCT: $localize`Mock basket product`,
    NUTRITION: $localize`Nutrition`,
    HEALTH_CHECK_UP_CUSTOMER_LEHMANN_UND_VOSS: $localize`Health Check-up | Customer LUV`,
    PREVENTION_COURSES_ONLINE_ONLY: $localize`Prevention courses - online only`,
    CORPORATE_FITNESS: $localize`Corporate fitness`,
    URBAN_SPORTS_CLUB: $localize`Urban Sports Club - monthly`,
    URBAN_SPORTS_CLUB_PRIVATE_MEMBERSHIP: $localize`Urban Sports Club - Private Membership`,
    BOOMERANG_REISEN: $localize`Boomerang Reisen`,
    // INH-Core-only value: no legacy counterpart exists.
    UNKNOWN_CATEGORY: $localize`Unknown category`,
    SDK_GESUNDWERKER_PREVENTIVE_CARE: $localize`SDK Gesundwerker - Preventive Care`,
    SDK_GESUNDWERKER_AMBULATORY_BUDGET: $localize`SDK Gesundwerker - Ambulatory Budget`,
    SDK_GESUNDWERKER_DENTAL_BUDGET: $localize`SDK Gesundwerker - Dental Budget`,
    SDK_GESUNDWERKER_INPATIENT_CARE: $localize`SDK Gesundwerker - Inpatient Care`
};
